import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-adduom',
  templateUrl: './adduom.component.html',
  styleUrls: ['./adduom.component.css']
})
export class AdduomComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  uomColl: any = [];

  uomform = new FormGroup({
    uomid: new FormControl(0),
    uomname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Uom";

  @Input() uomid: number = 0
  @Input() uomname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.uomid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.uomform.reset();
      this.fnInitializeuom();

      if (this.uomid > 0) {
        this.fngetuom();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.uomid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeuom() {
    this.uomform.setValue({

      uomid: 0,
      uomname: '',
      inactive: false,
    })
  }

  //Get 
  fngetuom() {

    var data = {
      'uomid': this.uomid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;
        
          var editdata = this.uomColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.uomform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'uomid': this.uomid,
          'uomname': this.uomform.get('uomname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.uomform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckUom(data).subscribe(
          (res) => {
         
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.uomform.get('uomid').value > 0) {
                //Update Department
                this.fnSetUom(data);
              }
              else {
                //Insert Department
                this.fnInsertUom(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.uomform.controls['uomname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertUom(data) {

    this.appService.fnInsertUom(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().status === 200) {

          var result = res.json().result;

         
          var rtnuomid = 0;
          if (result.length > 0) {
            rtnuomid = result[0].uomid
          }
          this.toastr.success('', "The New UOM has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.uomid);

          this.emitData.emit(rtnuomid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetUom(data) {

    this.appService.fnSetUom(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The UOM has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.uomid, data.uomname);

          this.emitData.emit(this.uomid);
         
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.uomform.setValue({

      uomid: deptBO.uomid,
      uomname: deptBO.uomname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
  
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }

    
       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
           //console.log(res)
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
